<template>
<div class="card-player">
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :style="{transform: `rotate(${rotation})`}" :height="height" :width="width" :fill="fill" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><g transform="translate(50 50) rotate(180) translate(-50 -50)"><path d="M30.5,34.2c1.2-2.6,4.7-5.5,9.8-7.9c0.4-0.2,0.9-0.3,1.3-0.3c0.7,0,1.3,0.2,1.8,0.6c2.7,2,4.5,3.5,5.2,4.2   c-0.1,0.5-0.8,1.9-3.5,4.5c-0.4,0.3-0.8,0.6-1.3,0.7l-9,2.6l1.1,1.2c0.2,0.2,0.4,0.5,0.5,0.7l8-2.3c0.8-0.2,1.6-0.7,2.2-1.3   c4.2-4.1,4.2-5.7,4.2-6.2c0-0.6-0.2-1-0.6-1.4c-0.9-0.9-3.6-3-5.6-4.5c-0.9-0.7-2.1-1.1-3.2-1.1c-0.8,0-1.6,0.2-2.3,0.5   c-3.4,1.6-9.1,4.8-11,9.1C29.2,33.3,29.9,33.6,30.5,34.2z"/><path d="M57.4,38.7l8,4.4c0.1-0.4,0.2-0.8,0.4-1.1l0.6-0.9l-7.8-4.4c-0.4-0.2-0.8-0.6-1.1-1c-2-3.1-2.4-4.7-2.4-5.1   c0.9-0.5,3-1.5,6.1-2.9c1-0.5,2.2-0.3,3.1,0.4c2.8,2.2,4.9,4.4,6.3,6.5c0.6-0.5,1.4-0.8,2.2-0.8c-1.9-3.1-5-5.8-7-7.5   c-0.9-0.7-2.1-1.2-3.3-1.2c-0.7,0-1.5,0.2-2.2,0.5c-2.3,1-5.4,2.4-6.5,3.1C53.3,29,53,29.4,52.8,30c-0.1,0.5-0.5,2,2.7,7   C56,37.7,56.7,38.3,57.4,38.7z"/><path d="M34.7,59.3h30.9c1,0,1.9-0.5,2.5-1.1H32.3C32.9,58.8,33.7,59.3,34.7,59.3z"/><path d="M50,96c-9.8,0-19-3.8-26-10.6c-7-6.8-10.9-16-11.1-25.7l0-0.1l0-0.1c0.1-0.3,1.4-8.5,3.8-14.1c2.4-5.6,5.8-9.6,8.2-11.9   c0.9-0.8,2-1.3,3.2-1.3c1.2,0,2.4,0.5,3.3,1.4l5.3,5.4c1.3,1.4,1.7,3.4,0.9,5.1l-5,11.1c-0.3,0.7-0.2,1.4,0.2,2   c0.4,0.6,1.1,1,1.8,1h30.9c0.7,0,1.3-0.3,1.7-0.9c0.4-0.6,0.5-1.3,0.3-1.9l-3.3-10.1c-0.4-1.3-0.3-2.6,0.4-3.8l3.9-6.6   c0.8-1.4,2.3-2.3,4-2.3c1.4,0,2.6,0.6,3.5,1.6c2.5,3,5.8,7.4,7.5,11.6c2.6,6.5,3.3,12.9,3.3,13l0,0.1l0,0.2C87,79.4,70.4,96,50,96z    M15.3,59.7c0.4,18.8,15.9,34,34.7,34c19.2,0,34.7-15.6,34.7-34.7l0-0.2c-0.1-0.6-0.8-6.4-3.1-12.2c-1.6-3.9-4.7-8.1-7.1-10.9   c-0.4-0.5-1.1-0.8-1.8-0.8c-0.8,0-1.6,0.4-2,1.1l-3.9,6.6c-0.3,0.6-0.4,1.3-0.2,1.9l3.3,10.1c0.4,1.4,0.2,2.8-0.6,4   c-0.8,1.2-2.1,1.8-3.6,1.8H34.7c-1.5,0-2.9-0.8-3.7-2c-0.8-1.3-0.9-2.8-0.3-4.2l5-11.1c0.4-0.9,0.2-1.9-0.5-2.6l-5.3-5.4   c-0.4-0.4-1-0.7-1.7-0.7c-0.6,0-1.2,0.2-1.6,0.7c-2.3,2.2-5.4,5.9-7.7,11.2C16.7,51.3,15.4,58.8,15.3,59.7z"/><path d="M38.3,87.2l-0.1,0.6l-1-1.2c-0.1-0.2-3-5.4-1.3-9.5c0.4-1.6,2.5-8.7,5.2-10.2c0.7-0.4,1.4-0.9,2.2-1.5   c1.8-1.3,3.9-2.8,6.3-2.8c0.2,0,0.4,0,0.5,0c3.1,0.3,11,4.8,11.8,7.5c1,3.7,1.5,6.7,1.7,9.1c0.1,1.3,0.2,2.5,0.2,3.4   c0,1.7-1,3.4-12.3,4.2C45.3,87.2,39,87.2,38.3,87.2z M49.6,64.9c-1.6,0-3.3,1.2-4.9,2.4c-0.9,0.6-1.7,1.2-2.5,1.6   c-1.4,0.8-3.3,5.6-4.1,8.9l0,0.1l0,0.1c-1.1,2.4,0.2,5.6,0.8,6.9c1.7,0,6.6-0.1,11.5-0.4c9.6-0.7,10.8-1.8,11.1-2.1   c0-2.3-0.3-6.3-1.8-11.7c-0.4-1.3-6.8-5.5-9.8-5.8C49.8,64.9,49.7,64.9,49.6,64.9z"/><path d="M63.5,79.4c1.7,9.4-5.8,15.1-13.5,15.1s-14.1-6.3-14.1-14.1c0-3.3,1,4.3,2.8,3.4c2.4-1.2,6.3-10.2,10.8-10.2   c3.9,0,7.6,9,10.2,9.7C62.4,84.1,62.8,75.5,63.5,79.4z"/></g>
  </svg>
  <span :style="playerNamePosition">{{ name }}</span>
  <slot name="action"></slot>
</div>
</template>

<script>
export default {
  name: 'Player',

  props: {
    rotation: {
      type: String,
      default: '0deg'
    },
    width: {
      type: String,
      default: '100px'
    },
    height: {
      type: String,
      default: '100px'
    },
    name: {
      type: String,
      required: true
    },
    fill: {
      type: String,
      required: false,
      default: '#fff'
    }
  },

  computed: {
    playerNamePosition () {
      return {
        // transform: `rotate(${this.rotation})`
      }
    }
  }
}
</script>
